import React from 'react';
import { EventComponent } from 'components';

function Schedule() {
  return <EventComponent.Schedule />;
}

export default Schedule;
